import DgoContainer from "@/components/DGOContainer/DGOContainer.vue";
import DgoRow from "@/components/DGORow/DGORow.vue";
import DgoCol from "@/components/DGOCol/DGOCol.vue";
import NntPopup from "@/components/NNTPopup/NNTPopup.vue";
import Autenticado from "@/views/Templates/Autenticado/Autenticado.vue";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapActions, mapState, mapMutations } from "vuex";

export default {
    components: {
        FontAwesomeIcon,
        DgoContainer,
        Autenticado,
        NntPopup,
        DgoRow,
        DgoCol,
    },
    data() {
        return {
            search: '',
        };
    },
    computed: { 
        ...mapState('token', ['tokens']),
        ...mapState('unity-files', {
            files: 'data',
            loadingFiles: 'loading',
            successFiles: 'success',
            errorFiles: 'error',
        }),
        ...mapState('unity-types-files', {
            unityFiles: 'data',
            loadingUnityFiles: 'loading',
            successUnityFiles: 'success',
            errorUnityFiles: 'error',
        }),
        ...mapState('user-files', {
            userFiles: 'data',
            loadingUserFiles: 'loading',
            successUserFiles: 'success',
            errorUserFiles: 'error',
        }),
        mergeFiles() {
            let files = [{ id: Math.random() * (10000 - 0) + 0, name: '', files: this.userFiles }];
            return (files.concat(this.unityFiles)).concat(this.files);
        },
        filteredItems() {
            return this.requestFiles.filter(item => {
               return item.type.indexOf(this.search.toLowerCase()) > -1
            })
        }
    },
    methods: {
        ...mapActions('unity-files', ['requestFiles']),
        ...mapActions('unity-types-files', ['requestUnityTypesFiles']),
        ...mapActions('user-files', ['requestUserFiles']),
        ...mapMutations('token', ['logout']),
        //searchFiles() { if (this.search) { this.requestFiles({ search: this.search }); } }
        searchFiles() { 
            if (this.search) { 
                this.requestFiles({ search: this.search }); 
                this.requestUnityTypesFiles({ search: this.search }); 
                this.requestUserFiles({ search: this.search }); 
            }
        },
        isRefresh(){
            window.location.href = "https://azhoteis.com.br/arquivos"
        }
    },
    created() {
        this.requestFiles();
        this.requestUnityTypesFiles();
        this.requestUserFiles();
    },
}
